/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1,
  style: {
    "display": "flex"
  }
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "等待激活", -1);
const _hoisted_6 = {
  key: 0
};
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiGetTeamManageList, apiSendSms, apiStopOrStartAccount } from '@/api/user';
import WarningToolTips from './module/warningToolTips.vue';
import AddEditAccount from './module/addEditAccount.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'teamManage',
  setup(__props, {
    expose
  }) {
    const columns = [{
      label: '用户名',
      prop: 'UserName'
    }, {
      label: '姓名',
      prop: 'Realname'
    }, {
      label: '电话',
      prop: 'Phone'
    }, {
      label: '邮箱',
      prop: 'Email'
    }, {
      label: '角色组权限',
      prop: 'Roles'
    }, {
      label: '游戏权限',
      prop: 'GameNames',
      slot: 'GameNames'
    }, {
      label: '最后登录时间',
      prop: 'LastloginAt',
      slot: 'LastloginAt'
    }, {
      label: '操作',
      action: true
    }];
    const addEditAccountRef = ref();
    const handleClick = (type, data) => {
      if (type === 'edit') {
        addEditAccountRef.value.show({
          type,
          data
        });
      } else {
        let params = {
          user_id: data.Id,
          disable: data.Disabled === 0 ? 1 : 0
        };
        apiStopOrStartAccount(params).then(res => {
          if (res.code === 0) {
            getTableData();
            ElMessage.success(res.msg);
          }
        });
      }
    };
    const getTableData = async () => {
      tableLoading.value = true;
      const res = await apiGetTeamManageList({
        page: current.value,
        page_size: pageSize.value
      });
      tableLoading.value = false;
      if (res.code === 0) {
        tableData.value = res.data;
        total.value = res.pageTotal;
      }
    };
    // 重新发送短信
    const handleResendSmS = record => {
      const data = {
        Phone: record.Phone,
        Type: 5
      };
      apiSendSms(data).then(res => {
        if (res.code === 0) {
          getTableData();
        }
      });
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      // handleSearch,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    onMounted(() => {
      getTableData();
    });
    const show = () => {
      addEditAccountRef.value.show({
        type: 'add'
      });
    };
    expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_u_card_pane, {
        name: "teamManage"
      }, {
        default: _withCtx(() => [_createVNode(UTable, {
          options: columns,
          data: _unref(tableData),
          loading: _unref(tableLoading),
          pagination: "",
          "current-page": _unref(current),
          "page-size": _unref(pageSize),
          total: _unref(total),
          onSizeChange: _unref(handleSizeChange),
          onCurrentChange: _unref(handleCurrentChange)
        }, {
          GameNames: _withCtx(({
            scope
          }) => [scope.row.GameNames === '[]' ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(scope.row.GameNames), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_2, "-"))]),
          LastloginAt: _withCtx(({
            scope
          }) => [scope.row.IsActive ? (_openBlock(), _createElementBlock("span", _hoisted_3, [scope.row.LastloginAt > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode(_toDisplayString(_ctx.$filters.formatDate(scope.row.LastloginAt)) + _toDisplayString(scope.row.LastloginIp ? `（${scope.row.LastloginIp}）` : ""), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode("-")], 64))])) : (_openBlock(), _createElementBlock("span", _hoisted_4, [_hoisted_5, _createVNode(WarningToolTips, {
            onOnResendSmS: $event => handleResendSmS(scope.row)
          }, null, 8, ["onOnResendSmS"])]))]),
          action: _withCtx(({
            scope
          }) => [!scope.row.IsMaster ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            onClick: $event => handleClick('edit', scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("编辑")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            link: "",
            type: scope.row.Disabled === 0 ? 'danger' : 'success',
            onClick: $event => handleClick('start', scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.Disabled === 0 ? '停用' : '启用'), 1)]),
            _: 2
          }, 1032, ["type", "onClick"])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["data", "loading", "current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])]),
        _: 1
      }), _createVNode(AddEditAccount, {
        ref_key: "addEditAccountRef",
        ref: addEditAccountRef,
        onSuccess: getTableData
      }, null, 512)], 64);
    };
  }
});